import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import {AttestationBatchService} from "@core/services/attestations/attestation-batch/attestation-batch.service";
import {StockStatus} from "@core/services/attestations/stock-status/stock-status.model";
import {StockStatusService} from "@core/services/attestations/stock-status/stock-status.service";

@Injectable({
    providedIn: 'root'
})
export class AttestationsResolver implements Resolve<any> {

    private _managementEntity: string = '';

    /**
     * Constructor
     */
    constructor(
        private _attestationBatchService: AttestationBatchService,
        private _stockStatusService: StockStatusService
    ) {

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        // Fork join multiple API endpoint calls to wait all of them to finish

        let resolList: Observable<any>[] = [of({})];

        resolList.push(this._stockStatusService.getAll())


        return forkJoin(resolList)
    }
}
